<template>
   <div class="page bg" 
    :class="PdftStore.fromData.questionnaireInfo?.grade == 1
    ? 'qingtong'
    : PdftStore.fromData.questionnaireInfo?.grade == 2
    ? 'baiyin'
    : PdftStore.fromData.questionnaireInfo?.grade == 3
    ? 'huangjin'
    : PdftStore.fromData.questionnaireInfo?.grade == 4
    ? 'baijin'
    : PdftStore.fromData.questionnaireInfo?.grade == 5
    ? 'zuanshi'
    : ''
    "
   >
        <!-- <div class="title">
            ACNAC
        </div> -->
        <div class="title_t">碳中和进程评级报告</div>
        <div class="line_txt"></div>
        <!-- 白线 -->
        <div class="line"></div>
        <!-- 认证图标 -->
        <div class="r_img"
        :class="PdftStore.fromData.questionnaireInfo?.grade == 1
        ? 'qingtong_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 2
        ? 'baiyin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 3
        ? 'huangjin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 4
        ? 'baijin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 5
        ? 'zuanshi_logo'
        : ''
        "
        >
            <div class="img_txt">
                <div class="txt_y">{{formatDateTimeYYs(PdftStore.fromData.questionnaireInfo?.evaluationDate)}}</div>
                <div class="top">Top</div>
                <div class="txt_n">{{PdftStore.fromData.questionnaireInfo?.top ? PdftStore.fromData.questionnaireInfo?.top : 0}}%</div>
                <RadianText :name="'arctext4'"/>
            </div>
        </div>

        <!-- 公司信息 -->
        <div class="company">
            <!-- <div class="felx">
                <div class="f_txt">{{$t('page1.company')}}  &nbsp;</div>
                <div class="f_txt">{{PdftStore.fromData.orgInfo?.orgName}}</div>
            </div> -->
            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">被评公司 :</a-col>
                <a-col class="f_txt1">{{PdftStore.fromData.orgInfo?.orgName}}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">报告周期 :</a-col>
                <a-col class="f_txt1">{{PdftStore.fromData.questionnaireInfo?.cycle}}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">得分 :</a-col>
                <a-col class="f_txt1" >{{PdftStore.fromData.questionnaireInfo?.score}}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">等级 :</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 1">青铜</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 2">白银</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 3">黄金</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 4">白金</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 5">钻石</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">评估时间 :</a-col>
                <a-col class="f_txt1">{{ PdftStore.fromData.questionnaireInfo?.checkTime ? PdftStore.fromData.questionnaireInfo.checkTime.substring(0, 7) : '' }}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">总部所在地 :</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.orgInfo?.provinceStr && PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.provinceStr}},{{PdftStore.fromData.orgInfo?.cityStr}}</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.orgInfo?.provinceStr && !PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.provinceStr}}</a-col>
                <a-col class="f_txt1" v-if="!PdftStore.fromData.orgInfo?.provinceStr && PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.cityStr}}</a-col>
                <a-col class="f_txt1" v-if="!PdftStore.fromData.orgInfo?.provinceStr && !PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.address}}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">企业行业 :</a-col>
                <a-col class="f_txt1">{{PdftStore.fromData.orgInfo?.industry}}</a-col>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">企业规模 :</a-col>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 1 ? 't_g_b' : ''">小</div>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 2 ? 't_g_b' : ''">中</div>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 3 ? 't_g_b' : ''">大</div>
            </a-row>

            <a-row class="mg_b">
                <a-col :span="2" class="f_txt f_width">碳中和目标年 :</a-col>
                <a-col class="f_txt1">{{PdftStore.fromData.questionnaireInfo?.targetYear}}</a-col>
            </a-row>
        </div>

        <!-- 白线 -->
        <div class="line_t"></div>

        <!-- logo -->
        <div class="flex_box">
            <div class="flex">
                <!-- <div class="tuv_img">
                    <img src="@/assets/img/ACNAClogo.png" alt="">
                </div> -->
                <div class="car_img">
                    <img src="@/assets/img/Mvgx02_18.png" alt="">
                </div>
                <div class="lineI"></div>
                <div class="tuvlogo_box">
                    <img src="@/assets/img/onelogo.png" alt="">
                </div>
            </div>
            
            <div class="logo_txt">
                <div>本报告由ACNAC委托</div>
                <div>TÜV SÜD核证并发布，MVGX TECH提供系统支持</div>
            </div>
        </div>
   </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
import RadianText from '@/components/radianText.vue'
export default {
    name: 'page1',
    components:{RadianText},
    setup() {
        const data = reactive({
            qingtong:require('@/assets/img/report_qingtong_bg.png'),
            baiyin:require('@/assets/img/report_baiyin_bg.png'),
            huangjin:require('@/assets/img/report_huangjin_bg.png'),
            baijin:require('@/assets/img/report_baijin_bg.png'),
            zuanshi:require('@/assets/img/report_zuanshi_bg.png'),
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.bg{
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: relative;
}
.qingtong{
    background: url('@/assets/img/report_qingtong_bg.png');
}
.baiyin{
    background: url('@/assets/img/report_baiyin_bg.png');
}
.huangjin{
    background: url('@/assets/img/report_huangjin_bg.png');
}
.baijin{
    background: url('@/assets/img/report_baijin_bg.png');
}
.zuanshi{
    background: url('@/assets/img/report_zuanshi_bg.png');
}
.qingtong_logo{
    background: url('@/assets/img/report_qingtong_logo.png');
}
.baiyin_logo{
    background: url('@/assets/img/report_baiyin_logo.png');
}
.huangjin_logo{
    background: url('@/assets/img/report_huangjin_logo.png');
}
.baijin_logo{
    background: url('@/assets/img/report_baijin_logo.png');
}
.zuanshi_logo{
    background: url('@/assets/img/report_zuanshi_logo.png');
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    .title{
        font-size: 88px;
        font-weight: 500;
        color: #FFFFFF;
        padding: 180px 0 0 130px;
        line-height: 113px;
    }
    .title_t{
        padding: 180px 0 0 130px;
        font-size: 114px;
        font-weight: bold;
        color: rgba(255,255,255,0.8);
        // padding: 0 0 0 130px;
        line-height: 147px;
    }
    .line_txt{
        margin: 50px 0 0 130px;
        width: 114px;
        height: 1px;
        border-radius: 50px;
        border: 6px solid rgba(255,255,255,0.4);
    }
    .line{
        width: 1383px;
        height: 8px;
        background: #FFFFFF;
        position: absolute;
        top: 35%;
        right: 0;
    }
    .r_img{
        width: 300px;
        height: 300px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 28%;
        left: 41%;
        .img_txt{
            position: relative;
            .txt_y{
                font-size: 14px;
                line-height: 0;
                color: #FFFFFF;
                position: absolute;
                top: 110px;
                left: 21px;
                transform: rotateZ(29deg);
            }
            .txt_c{
                font-size: 38px;
                font-weight: 600;
                position: absolute;
                top: 80px;
                left: 90px;
                color: #00DF9F;
            }
            .top{
                font-size: 14px;
                line-height: 0;
                color: #FFFFFF;
                position: absolute;
                top: 170px;
                right: 17px;
                transform: rotateZ(27deg);
            }
            .txt_n{
                font-size: 14px;
                line-height: 0;
                font-weight: 600;
                color: #FFFFFF;
                position: absolute;
                // top: 165px;
                // right: 17px;
                top: 190px;
                right: 22px;
                transform: rotateZ(30deg);
            }
        }
    }
    .company{
        margin-top: 660px;
        padding-left: 129px;
        .mg_b{
            margin-bottom: 50px;
        }
        .felx{
            display: flex;
            margin-bottom: 88px;
            .f_txt{
                font-size: 32px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 45px;
            }
        }
        .f_txt{
            font-size: 26px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 42px;
        }
        .f_txt1{
            font-size: 26px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 42px;
        }
        .t_border{
            // padding-bottom:5px;
            margin-right: 15px;
            color: rgba(255,255,255,0.5) !important;
            // border-bottom: 3px solid rgba(255,255,255,0.5);
        }
        .t_g_b{
            color: rgba(255,255,255,1) !important; 
            border-bottom: 3px solid #10b49c;
        }
    }
    .line_t{
        width: 1383px;
        height: 4px;
        background: #FFFFFF;
        opacity: 0.6;
        margin-left: 129px;
    }
    .flex_box{
        display: flex;
        padding-left: 129px;
        padding-right: 129px;
        justify-content: space-between;
        .flex{
            display: flex;
        }
        .tuv_img{
            width: 121px;
            height: 106px;
            margin-top: 50px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .car_img{
            width: 215px;
            height: auto;
            margin-top: 70px;
            
            img{
                width: 100%;
                height: auto;
            }
        }
        .lineI{
            width: 1px;
            height: 80px;
            margin: 70px 30px 0 30px;
            background: rgba(255,255,255,0.28);
        }
        .tuvlogo_box{
            width: 101px;
            height: 101px;
            margin-top: 50px;
            // margin-left: 49px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .logo_txt{
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: right;
            margin-top: 90px;
            display: flex;
            align-items: center;
            .img_min{
                width: 27px;
                height: 27px;
            }
        }
    }
}
.f_width{
    min-width: 200px !important;
}
</style>